<template>
    <div class="flex-centered">
        <!-- <div class="cat-cat-container">
            <div class="card">
                <div class="content">
                    <h2>01</h2>
                    <h3>Card One</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo quisquam quidem voluptate temporibus nam ducimus exercitationem similique nisi corrupti molestias incidunt vero doloremque ut quas enim labore, quos iste minima!</p>
                    <a href="#">Read More</a>
                </div>
            </div>
            <div class="card">
                <div class="content">
                    <h2>02</h2>
                    <h3>Card Two</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo quisquam quidem voluptate temporibus nam ducimus exercitationem similique nisi corrupti molestias incidunt vero doloremque ut quas enim labore, quos iste minima!</p>
                    <a href="#">Read More</a>
                </div>
            </div>
            <div class="card">
                <div class="content">
                    <h2>03</h2>
                    <h3>Card Three</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo quisquam quidem voluptate temporibus nam ducimus exercitationem similique nisi corrupti molestias incidunt vero doloremque ut quas enim labore, quos iste minima!</p>
                    <a href="#">Read More</a>
                </div>
            </div>
            <div class="cardz">
                <div class="front">
                    <img src="~@/assets/re.jpg" class="card-bg-img">
                <div class="content">
                    <h2>02</h2>
                    <v-icon
                    large
                    color="ploBlue"
                    >
                    mdi-home-city
                    </v-icon>
                    <h3>Real Estate</h3>
                    <a href="#">Hover</a>
                </div>
                </div>

                <div class="back">
                <div class="back-top cardz-bg1">
                    <div class="content">
                    <v-icon
                    large
                    color="ploBlue"
                    >
                    mdi-home-automation
                    </v-icon>
                    <h3>Smart City</h3>
                    <a href="#">Read More</a>
                    </div>
                </div>
                
                <div class="back-btm cardz-bg2">
                    <div class="content">
                    <v-icon
                    large
                    color="ploBlue"
                    >
                    mdi-home-group
                    </v-icon>
                    <h3>Housing</h3>
                    <a href="#">Read More</a>
                    </div>
                </div>
                </div>
            </div>
        </div> -->
        <div class="cat-container">

            <div v-for="(category) in categories" :key="category.id">
                
                <div class="card tilt" v-if="!category.sublinks">
                    <img  :src="require(`../assets/${category.image}`)" class="card-bg-img">
                    <div class="content">
                        <!-- <h2>{{category.id}}</h2> -->
                        <v-icon
                        large
                        color="ploBlue"
                        >
                        {{category.icon}}
                        </v-icon>
                        <h3>{{category.name}}</h3>
                        
                        <v-dialog
                        v-model="category.dialogz"
                        fullscreen
                        transition="dialog-bottom-transition"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                color="white"
                                v-bind="attrs"
                                v-on="on"
                                class="pop-btn"
                                >
                                <b>Read More</b>
                                </v-btn>
                            </template>
                            <v-card class="pop-body" :style="{'background': 'linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(' + require('../assets/' + category.bg +'') + ')  no-repeat fixed center', 'backgroundSize': 'cover'}"
                            >
                                <v-toolbar
                                dark
                                color="primary"
                                >
                                <v-btn
                                    icon
                                    dark
                                    @click="category.dialogz= false"
                                >
                                    <v-icon dark>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>{{category.name}}</v-toolbar-title>
                                </v-toolbar>
                                <div class="pop-container">
                                    <div class="pop-inner-div">
                                        <p class="p-no-mar-btm">{{category.details}}</p>
                                    </div>
                                    <div  class="pop-inner-div flex-container-holder" v-for="(subDetail) in category.subDetails" :key="subDetail.id">
                                        <div class="flex-container">
                                            <div class="flex-img-holder">
                                                <img :src="require(`../assets/${subDetail.logo}`)" class="">
                                            </div>
                                            <div class="flex-details">
                                                <h4 class="sub-details-heading">{{subDetail.name}}</h4>
                                                <p>{{subDetail.details}}</p>
                                                <a v-if="subDetail.link" :href="`${subDetail.link}`" class="web-link">Visit Website</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-container">
                                        <div class="pop-inner-div">
                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                            color="white darken-1"
                                            @click="category.dialogz = false"
                                            >
                                            close
                                            </v-btn>
                                        </v-card-actions>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </div>

                <!-- <div class="card tilt" v-else>
                    <img  :src="require(`../assets/${category.image}`)" class="card-bg-img">
                    <div class="content">
                        <h2>{{category.id}}</h2>
                        <v-icon
                        large
                        color="ploBlue"
                        >
                        {{category.icon}}
                        </v-icon>
                        <h3>{{category.name}}</h3>
                        
                        <v-dialog
                        v-model="category.dialogz"
                        fullscreen
                        transition="dialog-bottom-transition"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                color="white"
                                v-bind="attrs"
                                v-on="on"
                                class="pop-btn"
                                >
                                <b>Read More</b>
                                </v-btn>
                            </template>
                            <v-card class="pop-body" :style="{'background': 'linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(' + require('../assets/' + category.bg +'') + ')  no-repeat fixed center', 'backgroundSize': 'cover'}"
                            >
                                <v-toolbar
                                dark
                                color="primary"
                                >
                                <v-btn
                                    icon
                                    dark
                                    @click="category.dialogz= false"
                                >
                                    <v-icon dark>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>{{category.name}}</v-toolbar-title>
                                </v-toolbar>
                                <div class="pop-container">
                                    <div class="pop-inner-div">
                                        <p class="p-no-mar-btm">{{category.details}}</p>
                                    </div>
                                    <div  class="pop-inner-div flex-container-holder" v-for="(sublink) in category.sublinks" :key="sublink.id">
                                        <div class="neg">
                                            <div class="">
                                                <div class="flex-details">
                                                    <h4 class="sub-details-heading">{{sublink.name}}</h4>
                                                    <p>{{sublink.details}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex-container" v-for="(subDetail) in sublink.subDetails" :key="subDetail.id">
                                            <div class="flex-img-holder">
                                                <img :src="require(`../assets/${subDetail.logo}`)" class="">    
                                            </div>
                                            <div class="flex-details">
                                                <h4 class="sub-details-heading">{{subDetail.name}}</h4>
                                                <p>{{subDetail.details}}</p>
                                                <a v-if="subDetail.link" :href="`${subDetail.link}`" class="web-link">Visit Website</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-container">
                                        <div class="pop-inner-div">
                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                            color="red darken-1"
                                            @click="category.dialogz = false"
                                            >
                                            close
                                            </v-btn>
                                        </v-card-actions>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </div> -->

                <div class="cardz" v-else :key="category.id">
                    <div class="front">
                        <img :src="require(`../assets/${category.image}`)" class="card-bg-img">
                    <div class="content">
                        <!-- <h2>{{category.id}}</h2> -->
                        <v-icon
                        large
                        color="ploBlue"
                        >
                        {{category.icon}}
                        </v-icon>
                        <h3>{{category.name}}</h3>
                        <a href="#"><span class="desktop">Hover</span><span class="mobile">Tap</span></a>
                    </div>
                    </div>

                    <div class="back">
                        <div class="back-top" v-for="sublink in category.sublinks" :key="sublink.id">
                            <img :src="require(`../assets/${sublink.image}`)" class="card-bg-img-back card-bg-img-back-rad">
                            <div class="content">
                            <v-icon
                            large
                            color="ploBlue"
                            >
                            {{sublink.icon}}
                            </v-icon>
                            <h3>{{sublink.name}}</h3>
                            
                            <v-dialog
                            v-model="sublink.dialogz"
                            fullscreen
                            transition="dialog-bottom-transition"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    color="white"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="pop-btn"
                                    >
                                    <b>Read More</b>
                                    </v-btn>
                                </template>
                                <v-card  class="pop-body" :style="{'background': 'linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(' + require('../assets/' + sublink.bg +'') + ')  no-repeat fixed center', 'backgroundSize': 'cover'}">
                                    <v-toolbar
                                    dark
                                    color="primary"
                                    >
                                    <v-btn
                                        icon
                                        dark
                                        @click="sublink.dialogz= false"
                                    >
                                        <v-icon dark>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{category.name}}: {{sublink.name}}</v-toolbar-title>
                                    </v-toolbar>
                                    <div class="pop-container">
                                    <div class="pop-inner-div">
                                        <h2 class="">{{category.name}}</h2>
                                        <p class="p-no-mar-btm">{{category.details}}</p>
                                    </div>
                                    <div class="pop-inner-div">
                                        <h2 class="">{{sublink.name}}</h2>
                                        <p class="p-no-mar-btm">{{sublink.details}}</p>
                                    </div>
                                    <div  class="pop-inner-div flex-container-holder" v-for="(subDetail) in sublink.subDetails" :key="subDetail.id">
                                        <div class="flex-container">
                                            <div class="flex-img-holder">
                                                <img :src="require(`../assets/${subDetail.logo}`)" class="">
                                            </div>
                                            <div class="flex-details">
                                                <h4 class="sub-details-heading">{{subDetail.name}}</h4>
                                                <p>{{subDetail.details}}</p>
                                                <a v-if="subDetail.link" :href="`${subDetail.link}`" class="web-link">Visit Website</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-container">
                                        <div class="pop-inner-div">
                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                            color="white darken-1"
                                            @click="sublink.dialogz = false"
                                            >
                                            close
                                            </v-btn>
                                        </v-card-actions>
                                        </div>
                                    </div>
                                </div>
                                </v-card>
                            </v-dialog>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: "Sectors",
  data () {
      return {
        categories: [
            {
                id:1,
                icon:'mdi-transmission-tower',
                name:'Infrastructure & Telecom',
                details:'We provide full-service general contractor, design-builder, and construction management services. We pride ourselves on being a local builder deeply rooted in the communities where we build. Our team has years of experience in the construction industry, as well as have an exemplary track record of successful projects in the education, government, healthcare, hospitality, commercial, residential, and retail sectors. We have delivered multiple turnkey projects across Telecommunications and Information Technology. Our expert team provides management and leadership for projects involving all of our Technology, Engineering, and Design services.',
                image:'if.jpg',
                dialogz: false,
                bg: 'infbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'TRANSFORM ASSOCIATES INC.',
                        details:'Transform Associates is a full-service general contractor, design-builder and construction manager. We pride ourselves on being a local builder deeply rooted in the communities where we build and live. Our team has years of history and experience in the construction industry as well as an exemplary track record of education, government, healthcare, hospitality, mixed – use, office, residential and retail projects. At Transform we work as a team to complete projects professionally and within budget. We provide real value. We don’t cut corners nor sacrifice quality to reduce cost; rather we thoroughly analyze each project to remain on budget and on schedule.',
                        logo:'tf.png',
                        link:'http://www.transformassociatesinc.com/'
                    },
                    {
                        id: 2,
                        name:'ADP CONSULTANTS INC.',
                        details:'ADP Consultants, Inc. (ADPCI) is a highly qualified A/E/C firm offering various types of horizontal and vertical construction services, development, planning, architecture, engineering, design- build, and out-sourcing services to major clients in the United States and worldwide since 2002 with demonstrated experience in the successful management and implementation of various development projects in domestic and international markets.',
                        logo:'al.png',
                        link:'https://adpconsultantsinc.com/'
                    },
                    {
                        id: 3,
                        name:'ADP CONSTRUCTION',
                        details:'ADP construction is a company reputed to put the quality of construction at the foremost. our company delivers exceptional commercial interiors construction in dc metro area. We strive for excellence in our field. Our crew is experienced and well versed in construction details and its execution.',
                        logo:'at.png',
                        link:'https://adpconstructioninc.com/'
                    },
                    {
                        id: 4,
                        name:'CAELO COMMUNICATIONS',
                        details:'CAELO’s mission is to bring a new class of telecommunications infrastructure management and integration support service to clients and programs which combine technical expertise, program management, and innovative engineering solutions. Our strategic services cater to increased business performance by providing solutions for key metrics depending on the industry and the position of the company within the growth curve.',
                        logo:'cl.png',
                        link:'http://www.caelocommunications.com/'
                    },
                ]
            },
            {
                id:2,
                icon:'mdi-home-city',
                name:'Real Estate',
                details:'We deal in real estate investment consultancy, leasing and sale of properties directly from the leading developers, to provide unique property management services to our clients. We ensure our clients  get outstanding representation in every business done. We use proactive marketing and brokerage techniques that are necessary to navigate todays` challenging real estate.',
                image:'re.jpg',
                dialogz: false,
                bg: 'smcbg.jpg',
                sublinks:[
                    {
                        id:1,
                        icon:'mdi-home-automation',
                        name:'Smart City',
                        details:'We do construction of gated communities for private entities to develop housing for upscale communities, providing successful projects in the education, government, healthcare, hospitality, commercial, residential, retail sectors and all social amenities.',
                        image:'sc.jpg',
                        dialogz: false,
                        bg: 'smcbg.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'PLOUTUS HOLDINGS LLC',
                                details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                                logo:'ph.png',
                                link:'https://www.ploutus.com/'
                            },
                        ]
                    },
                    {
                        id:2,
                        icon:'mdi-home-group',
                        name:'Housing',
                        details:'With Government housing, we do development of limited scope and medium houses for governments in various nations, for their administrative staff.',
                        image:'ho.jpg',
                        dialogz: false,
                        bg: 'houbg.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'PLOUTUS HOLDINGS LLC',
                                details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                                logo:'ph.png',
                                link:'https://www.ploutus.com/'
                            },
                        ]
                    },
                ]
            },
            {
                id:3,
                icon:'mdi-monitor-cellphone',
                name:'IT & AI',
                details:'Our core competencies lies in Program Management, Systems Engineering / Integration, and Implementation.  Our focus on outstanding customer service and timely delivery of contracted services ensures our clients of a complete life cycle system solution at a competitive cost.',
                image:'it.jpg',
                dialogz: false,
                bg: 'itabg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'YOUNG ENTERPRISE SYSTEMS, INC',
                        details:'YES Inc. provides advanced systems engineering, professional services, information technology, and telecom solutions to State and Federal governments and commercial clients with its proven expertise in program management, systems engineering, and integration. YES Inc. is growing and currently well-positioned in its mission-critical market segments with highly successful past performance, sound technical, financial, and managerial capabilities.',
                        logo:'ye.png',
                        link:'http://yesys.com/'
                    },
                ]
            },
            {
                id:4,
                icon:'mdi-pickaxe',
                name:'Mining',
                details:'We mine prosperity, we are a devoted group of experts mining towards our success in East African Region, Africa. Mining gold and other precious elements that come along with raw gold ore. Our noble cause is creating employment opportunities for the local populace to give them a brilliant future.',
                image:'mi.jpeg',
                dialogz: false,
                bg: 'minbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'PLOUTUS HOLDINGS LIMITED (KENYA)',
                        details:'Ploutus Holdings (Kenya) Limited was founded to source precious metals and to start on our long-term strategic goal of gold mining. Currently, we have set up a testing facility to check the purity of the gold and are also in the process of developing a gold refinery in Kenya. We currently own 3 mines in which we have deployed the latest mining equipment, and are in the process of rolling out similar equipment to some of the mines that we are partnering with. We have established an exceptional supply chain with the miners in the area and have become one of the leading buyers of gold in Kenya.',
                        logo:'pk.png',
                        link:'http://www.kenyaploutus.com/'
                    },
                ]
            },
            {
                id:5,
                icon:'mdi-finance',
                name:'Trading',
                details:'From unadulterated Ceylon tea from Sri Lanka to high-quality grains from Brazil, we leverage our international presence to provide top quality food products.',
                image:'tr.png',
                dialogz: false,
                bg: 'fnbbg.jpg',
                sublinks:[
                    {
                        id:1,
                        icon:'mdi-food',
                        name:'Food & Beverages',
                        details:'With our long stretches of expertise, we deliver the highest quality of products to all our customers. We give uncommon consideration to developing, sourcing, bundling, and trading a portion of the world`s best tea and grains. We offer a wide scope of food and drink items.',
                        image:'fb.jpg',
                        dialogz: false,
                        bg: 'fnbbg.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'BAILEY TEA',
                                details:'Baily Tea USA Inc was founded as a family business with a simple idea to deliver the finest purest Ceylon Tea. We offer a wide range of the highest quality Tea from Sri Lanka to you. With expertise in the fields of “Herbal Tea”, “Fruit & Flower Tea” and mastery of ‘Ceylon Black Tea’, we offer our friendship, our services, and our commitment to you. Baily Tea was established by an experienced team, with decades of experience in growing, sourcing, packing, and exporting some of the world’s finest teas. Our goal is to provide 100% pure Ceylon tea fresh from the verdant hills of Sri Lanka and give you a unique opportunity to be a part of this 150-year industry.',
                                logo:'bt.png',
                                link:'https://www.bailytea.com/'
                            },
                        ]
                    },
                    {
                        id:2,
                        icon:'mdi-package-variant',
                        name:'Other Commodities',
                        details:'Undertaking projects and services universally with an exceptional spotlight on the African and Asian nations, We pay special attention to growing, sourcing, packaging, and exporting some of the world’s best commodities to our clientele.',
                        image:'oc.jpg',
                        dialogz: false,
                        bg: 'otcbg.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'PLOUTUS HOLDINGS LLC',
                                details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                                logo:'ph.png',
                                link:'https://ploutus.com/'
                            },
                        ]
                    },
                ]
            },
            {
                id:6,
                icon:'mdi-corn',
                name:'Agriculture',
                details:'With our involvement in trading, and our wide scope of associations in African and Asian countries, and our network of other food trading companies, we aim to becoming the best and a major player significantly in Agriculture.',
                image:'ag.jpg',
                dialogz: false,
                bg: 'agrbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'PLOUTUS GRAINS BRAZIL',
                        details:'The newest venture of the Ploutus Holdings group of companies is its involvement in the trading of grains from Brazil. With our wide range of connections in countries in Africa and Asia, as well as our network of other food trading companies, we aim to develop Ploutus Grains Brazil to be a major player in grain trading.',
                        logo:'pg.png',
                        link:''
                    },
                ]
            },
            {
                id:7,
                icon:'mdi-fire',
                name:'Oil & Gas',
                details:'Our Oil & Gas ventures are customer-focused and are driven by our philosophy of integrity, professionalism, and uncompromised commitment to satisfaction.',
                image:'oi.jpg',
                dialogz: false,
                bg: 'oilbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'PLOUTUS OIL & GAS LLC',
                        details:'PLOUTUS OIL & GAS, LLC is a U.S./ International based company, a leader in the energy business with an expansive network of contacts. We are a new-generation and dynamic oil & gas-trading company offering world-class services to traders around the globe. PLOUTUS has the resources to address a multitude of challenges for international businesses dealing in oil & gas. Whether it is hauling, trading, storage, or power generation to LNG, let us assist your company. We have the ability to bring American technology and expertise, whether it’s oil and gas, solar energy, or water purification. Our business customers range from major multinationals and refineries to local companies.',
                        logo:'po.png',
                        link:''
                    },
                    {
                        id: 2,
                        name:'BOUSSARD OIL & GAS LLC',
                        details:'Boussard USA, LLC is a certified Maryland Limited Liability Company.  Boussard USA, LLC serves as a seller of Nigerian petroleum products.',
                        logo:'bo.png',
                        link:'https://www.boussardusa.com/'
                    },
                ]
            },
            {
                id:8,
                icon:'mdi-plus-box-outline',
                name:'Healthcare',
                details:'Our goal is to make the global supply chain of essential items seamless. In recent times, we have positioned ourselves to face the challenges of the 21st century, including the COVID-19 pandemic.',
                image:'he.jpg',
                dialogz: false,
                bg: 'medbg.jpg',
                sublinks:[
                    {
                        id:1,
                        icon:'mdi-needle',
                        name:'Medical Supplies',
                        details:'As a response to the COVID-19 pandemic, we have combined the resources of reputable global companies and manufacturers in an effort to crossover borders and deliver fast and credible solutions to customers in every part of the globe, including governments and institutional clients. We specialize in the sourcing, trading, and distribution of premium medical supplies.',
                        image:'ms.jpg',
                        dialogz: false,
                        bg: 'medbg.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'ROMA LLC',
                                details:'As a response to the COVID-19 pandemic, we have combined the resources of reputable global companies and manufacturers in an effort to crossover borders and deliver fast and credible solutions to customers in every part of the globe, including governments and institutional clients. We specialize in the sourcing, trading, and distribution of premium medical supplies. Founded in 2019, Roma LLC (DBA Assistive Health) specializes in medical billing and coding, and is a one-stop-shop for any medical practice management. We work with multi-specialty hospitals to solo practices with an emphasis on their increased revenue. With our experienced onsite and offshore teams, we provide a comprehensive range of customizable services. In 2020, we launched One Test for Cancer in India, and are an authorized reseller of the OneTest in India for 20/20 Genesystems. 20/20 Genesystems is a US-based cancer diagnostics company, which has been developing cancer diagnostic products since 2008. It has created proprietary tests for lung and other types of cancer and operates a CLIA certiﬁed laboratory, catering to the needs of US hospitals.',
                                logo:'ro.png',
                                link:''
                            },
                        ]
                    },
                    {
                        id:2,
                        icon:'mdi-home-plus-outline',
                        name:'Home Care',
                        details:'We provide personal care support staff through a private service provider/organization, or through your Home Care Package (HCP), for the elderly and people living with disabilities. Depending on your needs, you could receive personal care from support care staff, on shift basis (short shifts), or 24 hour care (on shift basis) as well.',
                        image:'hc.jpg',
                        dialogz: false,
                        bg: 'hocbg.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'EMPOWER LLC',
                                details:'We provide personal care support staff through a private service provider/organization, or through your Home Care Package (HCP), for the elderly and people living with disabilities. Depending on your needs, you could receive personal care from support care staff, on shift basis (short shifts), or 24 hour care (on shift basis) as well.',
                                logo:'ph.png',
                                link:''
                            },
                        ]
                    },
                ]
            },
            {
                id:9,
                icon:'mdi-recycle',
                name:'Renewable Energy',
                details:'We are an investor, manager, and facilitator of power generating facilities. Some of our current projects include a Vertical Farm in Bermuda and are currently in negotiations with the Governments of Ghana, Kenya, South Africa, and many other countries to set up Renewable Energy plants using Solar, waste-to-energy, Biomass, Hydro, Geothermal, and Wind.',
                image:'en.jpg',
                dialogz: false,
                bg: 'renbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'TRANSFORM ENERGY LLC',
                        details:'Transform Energy Services, LLC, is a member of Transform International LLC. We are based in Maryland USA with offices in New York. We are a privately owned partnership with a group turnover of approximately US $ 2 billion.',
                        logo:'te.png',
                        link:''
                    },
                ]
            },
            {
                id:10,
                icon:'mdi-diamond-stone',
                name:'Precious Metal Trading',
                details:'Ploutus Holdings LLC, through its subsidiary companies, is involved in the trading of gold, diamonds, and other precious metals. Our work extends to countries like the UAE, Thailand, Ghana, Kenya, and other African countries.',
                image:'me.jpg',
                dialogz: false,
                bg: 'metbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'GOLDWAY PRECIOUS METAL TRADING LLC (UAE)',
                        details:'Goldway Precious Metal Trading LLC is based in Dubai and is a joint venture with an equal partnership with Al Amry Group of Abu Dhabi, UAE, and Ploutus Holdings LLC, USA. Its work involves trading in Gold, Diamonds, and other precious metals, with contracts to supply gold in large volumes. We have been involved in precious metal trading for over 4 years working primarily in UAE, Thailand, Ghana, Kenya, and other African countries.',
                        logo:'gw.png',
                        link:'http://www.goldway.ae/'
                    },
                ]
            },
            {
                id:11,
                icon:'mdi-dots-horizontal',
                name:'Others',
                details:'Our team has years of experience in the construction industry, as well as have an exemplary track record of successful projects in the education, government, healthcare, hospitality, commercial, residential, and retail sectors.',
                image:'ot.jpg',
                dialogz: false,
                bg: 'othbg.jpg',
                subDetails:[
                    {
                        id: 1,
                        name:'PLOUTUS HOLDINGS LLC',
                        details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                        logo:'ph.png',
                        link:'https://ploutus.com/'
                    },
                ]
            },
        ]
      }
    },
    mounted(){

        var VanillaTilt=function(){"use strict";class t{constructor(e,i={}){if(!(e instanceof Node))throw"Can't initialize VanillaTilt because "+e+" is not a Node.";this.width=null,this.height=null,this.clientWidth=null,this.clientHeight=null,this.left=null,this.top=null,this.gammazero=null,this.betazero=null,this.lastgammazero=null,this.lastbetazero=null,this.transitionTimeout=null,this.updateCall=null,this.event=null,this.updateBind=this.update.bind(this),this.resetBind=this.reset.bind(this),this.element=e,this.settings=this.extendSettings(i),this.reverse=this.settings.reverse?-1:1,this.glare=t.isSettingTrue(this.settings.glare),this.glarePrerender=t.isSettingTrue(this.settings["glare-prerender"]),this.fullPageListening=t.isSettingTrue(this.settings["full-page-listening"]),this.gyroscope=t.isSettingTrue(this.settings.gyroscope),this.gyroscopeSamples=this.settings.gyroscopeSamples,this.elementListener=this.getElementListener(),this.glare&&this.prepareGlare(),this.fullPageListening&&this.updateClientSize(),this.addEventListeners(),this.updateInitialPosition()}static isSettingTrue(t){return""===t||!0===t||1===t}getElementListener(){if(this.fullPageListening)return window.document;if("string"==typeof this.settings["mouse-event-element"]){const t=document.querySelector(this.settings["mouse-event-element"]);if(t)return t}return this.settings["mouse-event-element"]instanceof Node?this.settings["mouse-event-element"]:this.element}addEventListeners(){this.onMouseEnterBind=this.onMouseEnter.bind(this),this.onMouseMoveBind=this.onMouseMove.bind(this),this.onMouseLeaveBind=this.onMouseLeave.bind(this),this.onWindowResizeBind=this.onWindowResize.bind(this),this.onDeviceOrientationBind=this.onDeviceOrientation.bind(this),this.elementListener.addEventListener("mouseenter",this.onMouseEnterBind),this.elementListener.addEventListener("mouseleave",this.onMouseLeaveBind),this.elementListener.addEventListener("mousemove",this.onMouseMoveBind),(this.glare||this.fullPageListening)&&window.addEventListener("resize",this.onWindowResizeBind),this.gyroscope&&window.addEventListener("deviceorientation",this.onDeviceOrientationBind)}removeEventListeners(){this.elementListener.removeEventListener("mouseenter",this.onMouseEnterBind),this.elementListener.removeEventListener("mouseleave",this.onMouseLeaveBind),this.elementListener.removeEventListener("mousemove",this.onMouseMoveBind),this.gyroscope&&window.removeEventListener("deviceorientation",this.onDeviceOrientationBind),(this.glare||this.fullPageListening)&&window.removeEventListener("resize",this.onWindowResizeBind)}destroy(){clearTimeout(this.transitionTimeout),null!==this.updateCall&&cancelAnimationFrame(this.updateCall),this.reset(),this.removeEventListeners(),this.element.vanillaTilt=null,delete this.element.vanillaTilt,this.element=null}onDeviceOrientation(t){if(null===t.gamma||null===t.beta)return;this.updateElementPosition(),this.gyroscopeSamples>0&&(this.lastgammazero=this.gammazero,this.lastbetazero=this.betazero,null===this.gammazero?(this.gammazero=t.gamma,this.betazero=t.beta):(this.gammazero=(t.gamma+this.lastgammazero)/2,this.betazero=(t.beta+this.lastbetazero)/2),this.gyroscopeSamples-=1);const e=this.settings.gyroscopeMaxAngleX-this.settings.gyroscopeMinAngleX,i=this.settings.gyroscopeMaxAngleY-this.settings.gyroscopeMinAngleY,s=e/this.width,n=i/this.height,l=(t.gamma-(this.settings.gyroscopeMinAngleX+this.gammazero))/s,a=(t.beta-(this.settings.gyroscopeMinAngleY+this.betazero))/n;null!==this.updateCall&&cancelAnimationFrame(this.updateCall),this.event={clientX:l+this.left,clientY:a+this.top},this.updateCall=requestAnimationFrame(this.updateBind)}onMouseEnter(){this.updateElementPosition(),this.element.style.willChange="transform",this.setTransition()}onMouseMove(t){null!==this.updateCall&&cancelAnimationFrame(this.updateCall),this.event=t,this.updateCall=requestAnimationFrame(this.updateBind)}onMouseLeave(){this.setTransition(),this.settings.reset&&requestAnimationFrame(this.resetBind)}reset(){this.event={clientX:this.left+this.width/2,clientY:this.top+this.height/2},this.element&&this.element.style&&(this.element.style.transform=`perspective(${this.settings.perspective}px) `+"rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)"),this.resetGlare()}resetGlare(){this.glare&&(this.glareElement.style.transform="rotate(180deg) translate(-50%, -50%)",this.glareElement.style.opacity="0")}updateInitialPosition(){if(0===this.settings.startX&&0===this.settings.startY)return;this.onMouseEnter(),this.fullPageListening?this.event={clientX:(this.settings.startX+this.settings.max)/(2*this.settings.max)*this.clientWidth,clientY:(this.settings.startY+this.settings.max)/(2*this.settings.max)*this.clientHeight}:this.event={clientX:this.left+(this.settings.startX+this.settings.max)/(2*this.settings.max)*this.width,clientY:this.top+(this.settings.startY+this.settings.max)/(2*this.settings.max)*this.height};let t=this.settings.scale;this.settings.scale=1,this.update(),this.settings.scale=t,this.resetGlare()}getValues(){let t,e;return this.fullPageListening?(t=this.event.clientX/this.clientWidth,e=this.event.clientY/this.clientHeight):(t=(this.event.clientX-this.left)/this.width,e=(this.event.clientY-this.top)/this.height),t=Math.min(Math.max(t,0),1),e=Math.min(Math.max(e,0),1),{tiltX:(this.reverse*(this.settings.max-t*this.settings.max*2)).toFixed(2),tiltY:(this.reverse*(e*this.settings.max*2-this.settings.max)).toFixed(2),percentageX:100*t,percentageY:100*e,angle:Math.atan2(this.event.clientX-(this.left+this.width/2),-(this.event.clientY-(this.top+this.height/2)))*(180/Math.PI)}}updateElementPosition(){let t=this.element.getBoundingClientRect();this.width=this.element.offsetWidth,this.height=this.element.offsetHeight,this.left=t.left,this.top=t.top}update(){let t=this.getValues();this.element.style.transform="perspective("+this.settings.perspective+"px) rotateX("+("x"===this.settings.axis?0:t.tiltY)+"deg) rotateY("+("y"===this.settings.axis?0:t.tiltX)+"deg) scale3d("+this.settings.scale+", "+this.settings.scale+", "+this.settings.scale+")",this.glare&&(this.glareElement.style.transform=`rotate(${t.angle}deg) translate(-50%, -50%)`,this.glareElement.style.opacity=`${t.percentageY*this.settings["max-glare"]/100}`),this.element.dispatchEvent(new CustomEvent("tiltChange",{detail:t})),this.updateCall=null}prepareGlare(){if(!this.glarePrerender){const t=document.createElement("div");t.classList.add("js-tilt-glare");const e=document.createElement("div");e.classList.add("js-tilt-glare-inner"),t.appendChild(e),this.element.appendChild(t)}this.glareElementWrapper=this.element.querySelector(".js-tilt-glare"),this.glareElement=this.element.querySelector(".js-tilt-glare-inner"),this.glarePrerender||(Object.assign(this.glareElementWrapper.style,{position:"absolute",top:"0",left:"0",width:"100%",height:"100%",overflow:"hidden","pointer-events":"none"}),Object.assign(this.glareElement.style,{position:"absolute",top:"50%",left:"50%","pointer-events":"none","background-image":"linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",width:`${2*this.element.offsetWidth}px`,height:`${2*this.element.offsetWidth}px`,transform:"rotate(180deg) translate(-50%, -50%)","transform-origin":"0% 0%",opacity:"0"}))}updateGlareSize(){this.glare&&Object.assign(this.glareElement.style,{width:`${2*this.element.offsetWidth}`,height:`${2*this.element.offsetWidth}`})}updateClientSize(){this.clientWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,this.clientHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight}onWindowResize(){this.updateGlareSize(),this.updateClientSize()}setTransition(){clearTimeout(this.transitionTimeout),this.element.style.transition=this.settings.speed+"ms "+this.settings.easing,this.glare&&(this.glareElement.style.transition=`opacity ${this.settings.speed}ms ${this.settings.easing}`),this.transitionTimeout=setTimeout(()=>{this.element.style.transition="",this.glare&&(this.glareElement.style.transition="")},this.settings.speed)}extendSettings(t){let e={reverse:!1,max:15,startX:0,startY:0,perspective:1e3,easing:"cubic-bezier(.03,.98,.52,.99)",scale:1,speed:300,transition:!0,axis:null,glare:!1,"max-glare":1,"glare-prerender":!1,"full-page-listening":!1,"mouse-event-element":null,reset:!0,gyroscope:!0,gyroscopeMinAngleX:-45,gyroscopeMaxAngleX:45,gyroscopeMinAngleY:-45,gyroscopeMaxAngleY:45,gyroscopeSamples:10},i={};for(var s in e)if(s in t)i[s]=t[s];else if(this.element.hasAttribute("data-tilt-"+s)){let t=this.element.getAttribute("data-tilt-"+s);try{i[s]=JSON.parse(t)}catch(e){i[s]=t}}else i[s]=e[s];return i}static init(e,i){e instanceof Node&&(e=[e]),e instanceof NodeList&&(e=[].slice.call(e)),e instanceof Array&&e.forEach(e=>{"vanillaTilt"in e||(e.vanillaTilt=new t(e,i))})}}return"undefined"!=typeof document&&(window.VanillaTilt=t,t.init(document.querySelectorAll("[data-tilt]"))),t}();
                
        VanillaTilt.init(document.querySelectorAll(".tilt"), {
		max: 25,
		speed: 400
	});
	
    }
};
</script>
<style>
.flex-centered{
    display: flex;
    justify-content: center;
}

.cat-container {
  position: relative;
  display:flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  flex-wrap: wrap;
}

.cat-container .card {
    position: relative;
    width: 300px;
    height: 300px;
    margin: 30px;
    box-shadow: 20px 20px 50px rgb(0 0 0 / 15%);
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(255,255,255,0.5);
    border-left: 1px solid rgba(255,255,255,0.5);
    backdrop-filter: blur(2px);
}

.card-bg-img{
    opacity: 0.3;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
    border-radius: 15px;
}

.card-bg-img-back{
    opacity: 0.3;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
}

.back .back-top:nth-child(1) .card-bg-img-back-rad{
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.back .back-top:nth-child(2) .card-bg-img-back-rad{
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
}

.cat-container .card .content{
    padding: 20px;
    text-align: center;
    transition: .5s;
}

.cat-container .card .content h2, .cat-container .cardz .content h2{
    position: absolute;
    top: -30px;
    right: 30px;
    font-size: 8em;
    color: rgb(0 0 0 / 20%);
    pointer-events: none;
    z-index: -1;
}

.cat-container .card .content h3, .cat-container .cardz .content h3{
    font-size: 1.5em;
    color: #000;
}

.cat-container .card .content p, .cat-container .cardz .content p{
    font-size: 1em;
    color: #fff;
    font-weight: 300;
}

.cat-container .card .content a, .cat-container .cardz .content a, .v-btn.pop-btn{
    position: relative;
    display: inline-block;
    padding: 8px 20px;
    margin-top: 15px;
    background: #fff;
    color: #000;
    border-radius: 20px;
    text-decoration: none;
    font-weight: 500;
    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.cardz {
    width: 300px;
    height: 300px;
    margin: 30px;
    transform-style: preserve-3d;
    position: relative;
    transition: all .5s ease-in-out;
    transform-origin: 50% 50%;
    box-shadow: 20px 20px 50px rgb(0 0 0 / 15%);
    border-radius: 15px;
    border-top: 1px solid rgba(255,255,255,0.5);
    border-left: 1px solid rgba(255,255,255,0.5);
}


.cardz:hover{
    transform: rotatey(180deg);
}

.cardz > div {
    width: 100%;
    height: 100%;
    position:absolute;
    left: 0;
    top: 0;
    text-align: center;
}

.front{
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;

}
.back {
    z-index: 1;
    transform: rotatey(180deg);
    visibility:hidden;
 }

 .cardz:hover .front{
    visibility:hidden;
}

.cardz:hover .back{
    visibility:visible
}

.back-top{
  width: 100%;
  height: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.theme--light.v-card.pop-body{
    background: transparent;
    backdrop-filter: blur(2px);
    position: relative;
}

.pop-container{
    display: flex;
    flex-direction: column;
}

.pop-inner-div{
    /*padding: 20px;
    margin: 20px;
    backdrop-filter: blur(2px);
    position: relative;
    font-size: 15px;
    font-weight: 500;
    color: #000;*/
}

.pop-inner-div::before{
    /* content: '';
    position: absolute;
    background: #000;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    border-radius: 15px;*/
}

.v-application p.p-no-mar-btm{
    margin-bottom: 0;
}

.pop-container .flex-container-holder:nth-child(even) .flex-container{
    display: flex;
    flex-direction: row;
}

.pop-container .flex-container-holder:nth-child(odd) .flex-container{
    display: flex;
    flex-direction: row-reverse;
}

.flex-details{
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.pop-container .flex-container-holder:nth-child(even) .flex-container .flex-img-holder{
    margin-right: 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.pop-container .flex-container-holder:nth-child(odd) .flex-container .flex-img-holder{
    margin-left: 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.sub-details-heading{
    font-size: 20px;
    margin-bottom: 15px;
}

.web-link{
    text-decoration: none;
    background: #fff;
    width: 150px;
    padding: 10px 15px;
    text-align: center;
    border-radius: 15px;
    color: #000 !important;
    font-weight: 800;
    border: 1px solid #000;
}

.mobile{
    display: none;
}

@media screen and (max-width:768px) {

.mobile{
    display: block;
}

.desktop{
    display: none;
}
.pop-container .flex-container-holder:nth-child(even) .flex-container, .pop-container .flex-container-holder:nth-child(odd) .flex-container{
    display: flex;
    flex-direction: column;
}

.pop-container .flex-container-holder:nth-child(even) .flex-container .flex-img-holder, .pop-container .flex-container-holder:nth-child(odd) .flex-container .flex-img-holder {
    text-align: center;
    margin: 0;
}

.flex-container-holder img{
    width: auto;
    max-width: 100%;
}
}

</style>